import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { SLICE_NAME } from './treatmentsSlice';

export const treatmentsStateSelector = createSelector(
	(state) => state[SLICE_NAME],
	(state) => state.treatments,
);

export const useTreatmentsInternalUse = () => useSelector(treatmentsStateSelector);

/**
 * Checks if a specific treatment is enabled.
 *
 * @param {Object} store - The Redux store.
 * @param {string} splitName - The name of the treatment split.
 * @returns {boolean} True if the treatment is enabled, false otherwise.
 */
export const getIsTreatmentEnabled = (store, splitName) => {
	const treatments = treatmentsStateSelector(store);
	return treatments[splitName] === 'on';
};

/**
 * Checks if a specific treatment's value is equal to the expected value(s).
 *
 * @param {Object} store - The Redux store.
 * @param {string} splitName - The name of the treatment split.
 * @param {string|string[]} expectedValues - The expected value(s) of the treatment.
 * @returns {boolean} True if the treatment's value matches the expected value(s), false otherwise.
 */
export const getIsTreatmentEqualTo = (store, splitName, expectedValues) => {
	const treatments = treatmentsStateSelector(store);
	if (Array.isArray(expectedValues)) {
		return expectedValues.includes(treatments[splitName]);
	}
	return treatments[splitName] === expectedValues;
};
